import React, { useEffect, useState } from "react";
import { UserAddressesContainer } from "../../../../../pages/user/settings/user-addresses/styled";
import BarekamPagination from "../../../../../pages/orders/my/pagination/barekam-pagination";
import { RecipientsResponseModel } from "../../../../../pages/shared/models/api/recipinets-response.moel";
import recipientService from "../../../../../services/recipient.service";
import { User } from "../../../../../pages/shared/models/user/user";
import { RecipientCard } from "../../../../../pages/user/settings/recipients/recipient-card/recipient-card";
import { Grid } from "@mui/material";
import { StandardDialog } from "../../../../../pages/components/dialogs/standard-dialog/standard-dialog";
import { Message, MessageSections } from "../../../../../pages/components/message/message";
import { Recipient } from "../../../../../pages/shared/models/user/recipient/recipient";
import EditRecipient from "../../../../../pages/user/settings/recipients/edit-recipient";

const CustomerPersonalInfo = ({ customer }: { customer: User | undefined }) => {
    const [recipientsData, setRecipientsData] = useState({
        recipients: [],
        totalItems: 0,
        currentPage: 0,
        pageSize: 10
    } as RecipientsResponseModel);
    const [recipientToView, setRecipientToView] = useState<Recipient | undefined>();

    useEffect(() => {
        loadRecipients(recipientsData.currentPage);
    }, [])

    function loadRecipients(page: number) {
        recipientService.getRecipients({ relatedUser: customer?.userId }, recipientsData.pageSize, page)
            .then(response => {
                setRecipientsData(response);
            })
    }

    function handlePageChange(event: unknown, newPage: number) {
        loadRecipients(newPage - 1);
    }

    return (
        <UserAddressesContainer style={{ width: '100%' }}>
            <Grid container
                gridTemplateColumns={'repeat(auto-fill, minmax(22rem, 1fr))'}
                display={'grid'}
                rowGap={'1rem'}
                columnGap={'1rem'}
                padding={'1rem'}>
                {recipientsData.recipients.map((recipient) =>
                    <RecipientCard recipient={recipient}
                        onClick={() => setRecipientToView(recipient)}
                        isReadonly
                        key={recipient.recipientId} />
                )}
            </Grid>

            {recipientsData.totalItems > recipientsData.pageSize
                ? <BarekamPagination {...recipientsData} onPageChange={handlePageChange} />
                : <></>
            }

            <StandardDialog
                headerLabel={<Message messageKey={'recipient'} sectionId={MessageSections.USER} />}
                open={!!recipientToView}>
                <EditRecipient sx={{ boxShadow: 'unset' }}
                    recipient={recipientToView as Recipient || {}}
                    popupClosed={() => setRecipientToView(undefined)}
                    isReadonly />
            </StandardDialog>
        </UserAddressesContainer>
    )
};

export default CustomerPersonalInfo;
